import {
  createTheme,
  ThemeProvider,
  useMediaQuery,
  responsiveFontSizes,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsMobileScreen } from "./themeSlice";
import { stripeSelector } from "../features/stripe/stripeSlice";
import {
  applyHotelTheme,
  getCachedHotelTheme,
  resolveColors,
  resolveFontFamily,
  tripletToRgb,
} from "./apply-theme";
function MaterialTheme({ children }) {
  const dispatch = useDispatch();
  const isScreenSmall = useMediaQuery("(max-width:1199px)");
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const { hotelDetails } = useSelector(stripeSelector);
  const [webAppTheme, setWebAppTheme] = useState(getCachedHotelTheme);

  useEffect(() => {
    dispatch(setIsMobileScreen(isScreenSmall));
  }, [isScreenSmall]);

  // Hotel's webapptheme arrives with the hotel details (fetchpaymentDetails); until then the
  // theme cached from the last visit (already painted in index.js) is used.
  useEffect(() => {
    if (!hotelDetails?.hotelCode) return;
    applyHotelTheme(hotelDetails);
    setWebAppTheme(hotelDetails.webapptheme || null);
  }, [hotelDetails]);

  const colors = resolveColors(webAppTheme);

  const theme = responsiveFontSizes(
    createTheme({
      // Built from the universal theme tokens (src/theme/tokens.js), so MUI follows the hotel's
      // webapptheme the same way the Tailwind classes do.
      palette: {
        mode: prefersDarkMode ? "dark" : "light",
        primary: { main: tripletToRgb(colors.primary), contrastText: tripletToRgb(colors.onPrimary) },
        secondary: { main: tripletToRgb(colors.secondary), contrastText: tripletToRgb(colors.onSecondary) },
        error: { main: tripletToRgb(colors.danger) },
        success: { main: tripletToRgb(colors.success) },
        warning: { main: tripletToRgb(colors.warning) },
        black: { main: "#000000" },
        white: { main: "#ffffff" },
      },
      typography: {
        fontFamily: resolveFontFamily(webAppTheme),
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
        h1: {
          fontSize: "0.8125rem",
        },
        h2: {
          fontSize: "0.8125rem",
        },
        h3: {
          fontSize: "1rem",
        },
        h4: {
          fontSize: "1rem",
        },
      },
      components: {
        MuiContainer: {
          styleOverrides: {},
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1200,
          xl: 1536,
        },
      },
    })
  );
  return <ThemeProvider children={children} theme={theme} />;
}

export default MaterialTheme;
